import React from "react";
import { Result, List } from "antd";
import styles from "./OptinList.module.scss";
import { UserOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
const { optInList__content } = styles;
function OptinSelectCustomers({ customers, addCustomerCb }) {
    const { t } = useTranslation();
    return (
        <>
            <div className={optInList__content}>
                {customers.length > 0 ? (
                    <>
                        <List
                            rowKey={(item) => item.id}
                            dataSource={customers}
                            renderItem={(item) => (
                                <List.Item>
                                    <List.Item.Meta
                                        avatar={<UserOutlined />}
                                        description={
                                            <>
                                                {item.name ? (
                                                    <>
                                                        {item.name} <br />
                                                    </>
                                                ) : (
                                                    ""
                                                )}
                                                {item.phone ? (
                                                    <>
                                                        {item.phone} <br />
                                                    </>
                                                ) : (
                                                    ""
                                                )}
                                                {item.email}
                                            </>
                                        }
                                        onClick={() => addCustomerCb(item)}
                                    />
                                </List.Item>
                            )}
                        />
                    </>
                ) : (
                    <Result
                        status="warning"
                        title=""
                        extra={
                            <>
                                <p>{t("noClientsFound")}</p>
                            </>
                        }
                    />
                )}
            </div>
        </>
    );
}
export default OptinSelectCustomers;
